export default "__VITE_ASSET__BZTVHvlH__"